import { render, staticRenderFns } from "./RespecIAPModal.vue?vue&type=template&id=1db2b8e9&scoped=true"
import script from "./RespecIAPModal.vue?vue&type=script&lang=js"
export * from "./RespecIAPModal.vue?vue&type=script&lang=js"
import style0 from "./RespecIAPModal.vue?vue&type=style&index=0&id=1db2b8e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2b8e9",
  null
  
)

export default component.exports